import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import Vuelidate from 'vuelidate';
import './axios.js'

import "bootstrap/dist/css/bootstrap.min.css";
import "admin-lte/plugins/jquery/jquery";
import "admin-lte/plugins/bootstrap/js/bootstrap";
import "admin-lte/build/js/AdminLTE";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'


// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import vueCountryRegionSelect from 'vue-country-region-select'

import VueAwesomeSwiper from 'vue-awesome-swiper'

import axios from 'axios'

import 'swiper/swiper-bundle.css'
import VueMoment from 'vue-moment'
import moment from 'moment'

import JwPagination from 'jw-vue-pagination';

import './assets/styles/custom.css'
import './registerServiceWorker'

// axios.defaults.baseURL = 'http://103.153.62.26:8085/api/'

axios.defaults.headers.common.Accept = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_NAME_AXIOS

// axios.defaults.headers.common['Authorization'] = 'Bearer' + localStorage.getItem('access_token')
Vue.use(vueCountryRegionSelect)
Vue.use(VeeValidate)
Vue.use(VueTelInput)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueMoment, {
  moment,
})
Vue.use(moment);
Vue.component('jw-pagination', JwPagination);
Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
  });
  return formatter.format(value);
});
// Vue.component('vue-phone-number-input', VuePhoneNumberInput);

new Vue({
  router,
  store,
  VueAwesomeSwiper,
  render: h => h(App)
}).$mount('#app')
